import { render, staticRenderFns } from "./FollowerList.vue?vue&type=template&id=ce353a44&scoped=true&lang=pug"
import script from "./FollowerList.vue?vue&type=script&lang=ts"
export * from "./FollowerList.vue?vue&type=script&lang=ts"
import style0 from "./FollowerList.vue?vue&type=style&index=0&id=ce353a44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce353a44",
  null
  
)

export default component.exports